<template>
    <svg width="11" height="15" viewBox="0 0 11 15" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 7.5L10.5 0.138784V14.8612L0 7.5Z" />
    </svg>
</template>